import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { RevaluationReserveService } from './revaluation-reserve.service';
import * as CryptoJS from 'crypto-js';
import { FinancialpositionService } from '../../financialposition/financialposition.service';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-revaluation-reserve',
  templateUrl: './revaluation-reserve.component.html',
  styleUrls: ['./revaluation-reserve.component.scss']
})
export class RevaluationReserveComponent implements OnInit {
  reserveform: FormGroup;
  APPeriodId: any; isJump: any;
  revaluationdata: any
  revaluationvalue: any
  revaluationvalueLY: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formbuilder: FormBuilder, public commonService: CommonService, private router: Router, private revaluationservice: RevaluationReserveService, private balanceSheetService: FinancialpositionService, public sidenav: SideNavService) { }
  ngOnInit() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.getBalanceSheetData(this.APPeriodId);
      this.createreserve();
      this.getrevaluation(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
     // if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata()
          }
        })
     // }
      //else {
      //  this.showBubbledata = null
      //}
    //})
      this.clearfield();
    if (localStorage.getItem("SubmitStatus") == "true")
      this.reserveform.disable()
    }

  createreserve() {
    this.reserveform = this.formbuilder.group({
      RevaluationReserveId: new FormControl(),
      RevaluationReserveGrossStart: new FormControl(),
      SurplusOrDeficitArisingFromRevaluation: new FormControl(),
      GrossEnd: new FormControl(),
      GrossStart_LY: new FormControl(),
      SurplusOrDeficitArisingFromRevaluation_LY: new FormControl(),
      GrossEnd_LY: new FormControl(),
      RevaluationReserveAdditionalInformation: new FormControl(),
      APPeriodId: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.reserveform.reset()
      }
    })
  }

  save() {
    debugger
    if (this.validations()) {
      this.insertreservereval()
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }
  insertreservereval() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.reserveform.controls['APPeriodId'].setValue(this.APPeriodId);
    this.reserveform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'));
    const formdata = this.reserveform.getRawValue();
    this.revaluationservice.insertrevaluation(formdata).subscribe((data) => {
      this.reserveform.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Revaluation reserve", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'revaluationreserve') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }
  getBalanceSheetData(APPeriodId) {
    debugger
    //if (this.commonService.AccountTemplateId==11) {
    //  this.balanceSheetService.getBalanceSheetFRS101(APPeriodId).subscribe((data: any) => {
    //    this.revaluationdata = data;
    //    this.revaluationvalue = Math.abs(data.TranslationReserve);
    //    this.revaluationvalueLY = Math.abs(data.TranslationReserve_LY);
    //    this.reserveform.controls['GrossEnd'].disable();
    //  })
    //} else {
    this.balanceSheetService.getBalanceSheet(APPeriodId).subscribe((data:any) => {
      this.revaluationdata = data;
      this.revaluationvalue = Math.abs(data.RevaluationReserve);
      this.revaluationvalueLY = Math.abs(data.RevaluationReserve_LY);
      this.reserveform.controls['GrossEnd'].disable();
    })
    //}
  }

  getrevaluation(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.revaluationservice.getreserverevaluation(this.APPeriodId).subscribe((data: any) => {
      if (data) {
        this.reserveform.patchValue(data);
      }
      this.commonService.getNotesData();
    })
  }

  getlastyeardata() {
    this.revaluationservice.getreserverevaluation(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }
  back() {
    this.reserveform.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Revaluation reserve", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }
  calculations() {
    debugger
    var total = +this.reserveform.controls["RevaluationReserveGrossStart"].value + +this.reserveform.controls["SurplusOrDeficitArisingFromRevaluation"].value;
    this.reserveform.controls["GrossEnd"].setValue(total)
  }

  calculationsLY() {
    debugger
    var total = +this.reserveform.controls["GrossStart_LY"].value + +this.reserveform.controls["SurplusOrDeficitArisingFromRevaluation_LY"].value;
    this.reserveform.controls["GrossEnd_LY"].setValue(total)
  }
  validations() {
    debugger
    if (+this.reserveform.controls["GrossEnd"].value != this.revaluationvalue) {
      if(this.commonService.AccountTypeId == 2 && this.commonService.AccountTemplateId==8)
        Swal.fire("Andica Accounts Production", "Revaluation reserve at " + this.commonService.EndDate + " must tally with the Revaluation reserve field value in the Trial balance for the year " + this.commonService.StartYear + ".", "warning")
      else
        Swal.fire("Andica Accounts Production", "Revaluation reserve at " + this.commonService.EndDate + " must tally with the Revaluation reserve field value in the balance sheet for the year " + this.commonService.StartYear + ".", "warning")

      return false
    }
    //if (+this.reserveform.controls["GrossEnd_LY"].value != this.revaluationvalueLY) {
    //  Swal.fire("Andica Accounts", "'Revaluation reserve' at " + this.commonService.StartdateLastAPLY + " must tally with the'Revaluation reserve' field value in the balance sheet for the year " + this.commonService.LastYear + ".", "info")
    //  return false
    //}
    else {
      return true
    }
  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.reserveform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          if (this.save()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
